import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

// The Booking city of the company hotel and its Scan city flag. The RateShopper header reads it to show
// the "Booking ranking" button only for a hotel in an active Scan city (D6).
export const FIND_BOOKING_SCAN_CITY_QUERY: GraphQL = {
	name: 'findBookingScanCity',
	gql: gql`
		query findBookingScanCity($companyHotelId: Long!) {
			findBookingScanCity(companyHotelId: $companyHotelId) {
				id name onSaleCount scanActive
			}
		}
	`,
};

// The Position state of the company hotel for one channel, one guest country and one device, over the
// stay nights of the next 6 months (the checks of the last 7 days; D11).
export const FIND_BOOKING_POSITION_STATE_FOR_PERIOD_QUERY: GraphQL = {
	name: 'findBookingPositionStateForPeriod',
	gql: gql`
		query findBookingPositionStateForPeriod($companyHotelId: Long!, $channel: DataProvider!, $country: String!, $device: DataPlatform!) {
			findBookingPositionStateForPeriod(companyHotelId: $companyHotelId, channel: $channel, country: $country, device: $device) {
				bookingCity { id name onSaleCount scanActive }
				countries { code name }
				devices { device hasData }
				scan { window scanDate checksPerNight everyNightUntil }
				months { month nights }
				nights {
					date onSaleCount
					compsetMiddle compsetMiddleAfter500 compsetMiddleOf
					compsetBandLo compsetBandLoAfter500 compsetBandHi compsetBandHiAfter500
				}
				hotels {
					hotelId bookingHotelId name isMain preferredTier sameCity bookingCityName
					typical typicalAfter500
					middleHalfLo middleHalfLoAfter500 middleHalfHi middleHalfHiAfter500
					best worst
					compsetRank compsetOf levelWithNeighbour
					compsetPriceRank compsetPriceOf
					cityDearerShare cityPriceRank cityOnSaleCount
					typicalPrice reviewScore reviewCount
					typical4WeeksEarlier reviewScore4WeeksEarlier
					nightCounts { total withPosition notIn500 soldOut notFound }
					months {
						month nights withPosition soldOut typical typicalAfter500
						compsetRank compsetOf cityDearerShare compsetPriceRank compsetPriceOf
					}
					cells {
						date state position best worst checks checksFound price
						cityDearerShare compsetRank compsetOf compsetPriceRank hasPriceCheck
					}
				}
				priceLink { nights pairsUntied pairsDearerLower }
			}
		}
	`,
};
